import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'hooks/useTranslation';
import { TRANSLATION_KEYS } from '../../../constants';
import styles from './LastResults.module.scss';

const VARIANT_BY_RESULT = {
  WIN: 'win',
  DRAW: 'draw',
  LOSS: 'loss',
};

const LastResults = ({ items = [], title }) => {
  const { translationMapper } = useTranslation();
  const translations = translationMapper(TRANSLATION_KEYS);
  const displayTitle = title || translations.LAST_MATCHES;

  if (!items.length) return null;

  const lastOrder = items.reduce(
    (max, item) => (item.matchOrder > max ? item.matchOrder : max),
    -Infinity,
  );

  return (
    <div className={styles['last-results']}>
      <span className={styles['last-results__title']}>{displayTitle}</span>
      <ul className={styles['last-results__list']}>
        {items.map(item => {
          const variant = VARIANT_BY_RESULT[item.result];
          const isLast = item.matchOrder === lastOrder;

          return (
            <li
              key={`${item.matchOrder}-${item.result}`}
              className={styles['last-results__item']}
            >
              <span
                className={classNames(
                  styles['last-results__pill'],
                  isLast && styles['last-results__pill--last'],
                  variant && styles[`last-results__pill--${variant}`],
                )}
              >
                {item.label}
              </span>
              {isLast && (
                <span
                  className={classNames(
                    styles['last-results__underline'],
                    variant && styles[`last-results__underline--${variant}`],
                  )}
                />
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LastResults;
